import { useTranslation } from 'react-i18next'
import { Button } from '@/shared/ui/button'
import { useTheme } from '@/shared/lib/theme'
import { cn } from '@/shared/lib/utils'

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggleTheme } = useTheme()
  const { t } = useTranslation()

  const ariaLabel =
    theme === 'dark' ? t('theme.toggle_to_light') : t('theme.toggle_to_dark')

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      aria-label={ariaLabel}
      className={cn(className)}
    >
      {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
    </Button>
  )
}

function SunIcon() {
  return (
    <svg viewBox="0 0 24 24" className="size-5 fill-primary-soft" aria-hidden="true">
      <path d="M12 4.5a1 1 0 0 1-1-1V2a1 1 0 1 1 2 0v1.5a1 1 0 0 1-1 1Zm5.657 3.843a1 1 0 0 1 0-1.414l1.06-1.061a1 1 0 1 1 1.415 1.414l-1.061 1.061a1 1 0 0 1-1.414 0ZM4.5 13a1 1 0 1 1 0-2H6a1 1 0 1 1 0 2H4.5Zm12.5-1a5 5 0 1 1-10 0 5 5 0 0 1 10 0Zm1.5 1h1.5a1 1 0 1 0 0-2H18.5a1 1 0 1 0 0 2ZM6.343 7.343a1 1 0 0 0 0-1.414L5.282 4.868A1 1 0 1 0 3.868 6.282l1.061 1.061a1 1 0 0 0 1.414 0ZM12 19.5a1 1 0 0 0-1 1V22a1 1 0 1 0 2 0v-1.5a1 1 0 0 0-1-1Zm7.657-2.843a1 1 0 0 0-1.414 0l-1.061 1.061a1 1 0 0 0 1.414 1.414l1.061-1.06a1 1 0 0 0 0-1.415ZM4.5 17a1 1 0 0 0-1.414 0l-1.061 1.061a1 1 0 0 0 1.414 1.414l1.061-1.06A1 1 0 0 0 4.5 17Z" />
    </svg>
  )
}

function MoonIcon() {
  return (
    <svg viewBox="0 0 24 24" className="size-5 fill-primary-soft" aria-hidden="true">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 1 0 21 12.79Z" />
    </svg>
  )
}
